import React, { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

function DagaProductCard({ img, price, title, link }) {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate(link)} className="bg-text_light_2 p-4 cursor-pointer">
      <div className="aspect-square object-cover">
        {img ? (
          <img
            className="h-full w-full object-contain"
            src={img}
            alt="product"
          />
        ) : (
          <Skeleton className="h-full" />
        )}
      </div>
      {/* <div className='my-1 mt-3 text-text_dark_2 text-base'>{price?<>&#8377;&nbsp;{price}</>:<Skeleton className='h-full'/>}</div> */}
      <div className="lato-regular mt-3 mb-3 text-text_dark_3 text-sm w-[calc(100%)] overflow-hidden whitespace-nowrap text-ellipsis text capitalize">
        {title ? <>{title}</> : <Skeleton className="h-full" />}
      </div>
    </div>
  );
}

export default DagaProductCard;
